<div class="row" *ngIf="!inCompletionState">
	<div class="col-12">
		<label for="transition" class="h4">{{ transitionStorage.title }}</label>
	</div>

	<div class="col-12 col-lg-6">
		<form [formGroup]="transitionForm" novalidate>
			<div class="form-group" [ngClass]="{
          'has-success': transitionForm.get('transition')?.valid && transitionSubmitted,
          'has-error': transitionForm.get('transition')?.invalid && transitionSubmitted
        }">
				<div class="input-group">
					<select id="transition" formControlName="transition" class="form-control"
						[disabled]="transitionStorage.transitions.length <= 0">
						<option value="">- Choose Decision -</option>
						<ng-container
							*ngFor="let transition of transitionStorage.transitions | removeDuplicateNames:'WORKFLOW_STATE_TYPES1'">
							<option [ngValue]="transition.WORKFLOW_STATE_TYPES1" [disabled]="
                  hasPropertyType(transition, 'Prerequisites Required') &&
                  (!transitionStorage.valid ||
                    transitionStorage.stateValid[transition.WORKFLOW_STATE_TYPES1.NAME] === false)
                ">
								{{
								(hasPropertyType(transition, 'Prerequisites Required') &&
								(!transitionStorage.valid ||
								transitionStorage.stateValid[transition.WORKFLOW_STATE_TYPES1.NAME] === false)
								? '* - '
								: '') +
								(transition.WORKFLOW_STATE_TYPES1.ACTION |
								resolveRegionalNonRegional: node.NODE_REGIONS[0])
								}}
							</option>
						</ng-container>
					</select>

					<span class="input-group-btn">
						<button class="btn btn-success" *ngIf="transitionStorage.transitioning" [disabled]="
                !transitionStorage.chosenToState?.ID ||
                loadingUsers ||
                !transitionStorage.transitionValid ||
                transitionStorage.transitioning
              ">
							<i class="fa fa-refresh fa-spin fa-fw" *ngIf="transitionStorage.transitioning"></i>
						</button>

						<!-- Custom confirm component -->
						<confirm-popover *ngIf="!transitionStorage.transitioning" type="success"
							[popoverMsg]="'Confirm your next step'" [popoverConfirmText]="'Submit'"
							[popoverCancelText]="'Cancel'" [popoverConfirmColor]="'primary'" [disabled]="
    !transitionStorage.chosenToState?.ID ||
    loadingUsers ||
    !transitionStorage.transitionValid ||
    transitionStorage.transitioning
  " [class]="'btn btn-success'" (onConfirm)="nodeTransitionAction()">
						</confirm-popover>
					</span>
				</div>

				<div class="mt-2">
					<span *ngIf="loadingUsers"><i class="fa fa-refresh fa-spin fa-fw"></i> Loading Users</span>

					<label *ngIf="users.length > 0">
						{{ transitionStorage.transitionToUserMessage }}
						<span class="bind-color">
							{{ node.NODE_REGIONS[0].REGION.CODE }} -
							{{ node.NODE_REGIONS[0].REGION.NAME }}
						</span>
						(Optional)
					</label>

					<select formControlName="assignToUser" class="form-control" *ngIf="users.length > 0">
						<option value="" [disabled]="disableSendToQueue">- No Assigned User (Send to Queue) -</option>
						<option *ngFor="let user of users" [ngValue]="user">
							{{ user.PERSON.FIRST_NAME }}
							{{ user.PERSON.MIDDLE_INITIAL ? ' ' + user.PERSON.MIDDLE_INITIAL : '' }}
							{{ user.PERSON.LAST_NAME }} ({{ user.USER_ID }})
						</option>
					</select>

					<div *ngIf="showUserErrorMessage" class="help-block">
						{{ userErrorMessage }}
					</div>
				</div>

				<div class="help-block" *ngIf="transitionStorage.showErrorMsg">
					{{ transitionStorage.errorMsg }}
				</div>

				<div *ngIf="transitionSubmitted && transitionForm.get('transition')?.errors">
					<div class="help-block" *ngIf="transitionForm.get('transition')?.hasError('required')">
						Please choose a transition.
					</div>
				</div>
			</div>
		</form>
	</div>
</div>